import { useSession } from '@pickleballinc/ui/components/global/SessionProvider';
import { useState } from 'react';

import {
  MyLeagueCard,
  MyLeagueCardProps,
} from '@/modules/league/my-leagues/components/MyLeagueCard';
import { FavoriteButton } from '@/modules/league/search-page/FavoriteButton';
import { FEATURE_FLAGS } from '@/utils/helpers/constants';

export const FavoriteMyLeagueCard = ({ ...leagueProps }: MyLeagueCardProps) => {
  const [isFavorited, setIsFavorited] = useState(leagueProps.league.isFavorite || false);
  const { session } = useSession();

  return FEATURE_FLAGS.ENABLE_NEW_CARDS ? (
    <MyLeagueCard {...leagueProps} />
  ) : (
    <div className='relative flex w-full hover:opacity-80'>
      {session?.user?.uuid ? (
        <div className='absolute right-2 top-2 z-10'>
          <FavoriteButton
            isFavorited={isFavorited}
            setIsFavorited={setIsFavorited}
            moduleUuid={leagueProps.league.LeagueID}
            isPlayerProfileLeaguesPage={leagueProps.isPlayerProfileLeaguesPage}
          />
        </div>
      ) : null}
      <MyLeagueCard {...leagueProps} />
    </div>
  );
};
